import React from 'react';

import {fetchEventNews} from '../../data/fetch';
import {useStoredDataChanged} from './useStoredDataChanged';
import Loader from './Loader';
import {useEventNewsArticle} from '../../data/hooks/news/useEventNewsArticle';
import {useEventNewsLoaded} from '../../data/hooks/news/useEventNewsLoaded';

const LoadNews = props => {
    const {eventId, articleId, children} = props,
        newsLoaded = useEventNewsLoaded(),
        article = useEventNewsArticle(eventId, articleId);

    useStoredDataChanged();
    return (
        <Loader skipSpinner={newsLoaded && article} promises={[fetchEventNews(eventId)]}>
            {children}
        </Loader>
    );
};

export default LoadNews;
